import { isEmpty } from 'lodash';

import type { GoodsItems } from '../../goods/goodsUtils';

interface WithGoods {
  goods?: GoodsItems;
}

export const hasSenderReceiverCountries = (state: WithGoods): boolean => {
  return !isEmpty(state.goods);
};
